import React from 'react'
import './style.scss'

interface MmRatingProps {
  text?: string
  number: number
  starSize?: number
  secFont?: boolean
  onChange?: (number: number) => void
  action?: React.MouseEventHandler<HTMLDivElement>
}

const MmRating: React.FC<MmRatingProps> = ({ text = 'MM Score', starSize = 16, secFont = true, number, action, onChange }) => {
  return (
    <div
      className='mmrating'
      onClick={action}>
      <div className={`mmrating__title${secFont ? ' --secFont' : ''}`}>{text}:</div>
      <div className='mmrating__stars'>
        {Array.from({ length: 5 }, (_, index) => {
          const isRed = index < number
          const starClass = `icon icon--star${isRed ? ' cPrimary' : ''} s${starSize}`
          return <i
            key={index}
            className={starClass}
            onClick={onChange
              ? () => {
                onChange(index + 1)
              }
              : undefined} />
        })}
      </div>
    </div>
  )
}

export default MmRating
